import { useEffect, useState, useCallback } from "react";
import type { StoryData } from "storyblok-js-client";
import config from "config/config";

const {
  storyblok: { accessToken },
} = config;

export default function useStory(originalStory: StoryData) {
  const [story, setStory] = useState(originalStory);

  const addBridge = (callback: () => void) => {
    const existingScript = document.getElementById("storyblokBridge");
    if (!existingScript) {
      const script = document.createElement("script");
      script.src = `https://app.storyblok.com/f/storyblok-latest.js?t=${accessToken}`;
      script.id = "storyblokBridge";
      document.body.appendChild(script);
      script.onload = () => {
        callback();
      };
    } else {
      callback();
    }
  };

  const initEventListeners = useCallback(() => {
    if (window.storyblok) {
      window.storyblok.init();
      // eslint-disable-next-line no-restricted-globals
      window.storyblok.on(["change", "published"], () => location.reload());

      window.storyblok.on("input", (event) => {
        const {
          content: { _uid },
        } = story;

        if (event.story.content._uid === _uid) {
          const newEvent = event;
          newEvent.story.content = window.storyblok.addComments(event.story.content, event.story.id);
          setStory(newEvent.story);
        }
      });
    }
  }, [story]);

  useEffect(() => {
    if (window.location.search.includes("_storyblok")) {
      addBridge(initEventListeners);
    } else {
      setStory(originalStory);
    }
  }, [originalStory, initEventListeners]);

  return story?.name === originalStory?.name ? story : originalStory;
}
